import type { ICasesPerStatusStats } from '@/domains/workflows/api/workflow-metrics';
import { useQuery } from '@tanstack/react-query';

import { workflowMetricsKeys } from '@/domains/workflows/api/workflow-metrics/query-keys';

export const useCasesPerStatusQuery = () => {
  const { data = { active: 0, completed: 0, failed: 0 } as ICasesPerStatusStats, isLoading } =
    // @ts-ignore
    useQuery({
      ...workflowMetricsKeys.workflowCasesPerStatusStats({}),
    });

  return {
    data,
    isLoading,
  };
};
